import React, { memo } from 'react';


import { ERROR_TYPES } from '../../../../constants/UIConstants';
import FormError from './FormError';

const FormErrors = ({errors, errorTexts}) => (
	<>
		{errors && errors.type && errors.type === ERROR_TYPES.required && <FormError
			message={(errorTexts && errorTexts[ERROR_TYPES.required]) ? errorTexts[ERROR_TYPES.required] : 'Required'}
		/>}
		{errors && errors.type && errors.type === ERROR_TYPES.min && <FormError
			message={(errorTexts && errorTexts[ERROR_TYPES.min]) ? errorTexts[ERROR_TYPES.min] : 'Min Value'}
		/>}
		{errors && errors.type && errors.type === ERROR_TYPES.max && <FormError
			message={(errorTexts && errorTexts[ERROR_TYPES.max]) ? errorTexts[ERROR_TYPES.max] : 'Max Value'}
		/>}
		{errors && errors.type && errors.type === ERROR_TYPES.minLength && <FormError
			message={(errorTexts && errorTexts[ERROR_TYPES.minLength]) ? errorTexts[ERROR_TYPES.minLength] : 'Min Length'}
		/>}
		{errors && errors.type && errors.type === ERROR_TYPES.maxLength && <FormError
			message={(errorTexts && errorTexts[ERROR_TYPES.maxLength]) ? errorTexts[ERROR_TYPES.maxLength] : 'Max Length'}
		/>}
		{errors && errors.type && errors.type === ERROR_TYPES.pattern && <FormError
			message={(errorTexts && errorTexts[ERROR_TYPES.pattern]) ? errorTexts[ERROR_TYPES.pattern] : 'Pattern Mismatch'}
		/>}
		{errors && errors.type && errors.type === ERROR_TYPES.custom && <FormError
			message={(errorTexts && errorTexts[ERROR_TYPES.custom]) ? errorTexts[ERROR_TYPES.custom] : 'Custom Error'}
		/>}
	</>
);

export default memo(FormErrors);
